import { render, staticRenderFns } from "./ProfileHeaderTabs.vue?vue&type=template&id=59f24daf&"
import script from "./ProfileHeaderTabs.vue?vue&type=script&lang=js&"
export * from "./ProfileHeaderTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports